import { useLanguage } from "@/context/LanguageContext";
import { usePageTitle } from "@/hooks/usePageTitle";
import { Reveal, Chapter } from "@/components/Shared";

const LegalPage = ({ kind }) => {
  const { t } = useLanguage();
  const content = t.legal[kind];
  usePageTitle(content.title);

  return (
    <main data-testid={`legal-page-${kind}`} className="pt-[76px]">
      <section className="py-20 lg:py-28">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <Reveal>
            <Chapter index="§" label="Orbit" />
            <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
              {content.title}
            </h1>
            <div className="mt-10 space-y-6">
              {content.body.map((paragraph, i) => (
                <p key={i} className="text-base leading-relaxed text-slate-600">
                  {paragraph}
                </p>
              ))}
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default LegalPage;
